import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "novalidate", "className", "children", "onSubmit"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import classNames from 'classnames';
import "./form.css";
/**
 * Renders a `<form>` element with styles to center the form and set a maximum width.
 * @deprecated Consider using the `<form>` element directly instead.
 */
export var Form = function Form(_ref) {
  var id = _ref.id,
    _ref$novalidate = _ref.novalidate,
    novalidate = _ref$novalidate === void 0 ? false : _ref$novalidate,
    className = _ref.className,
    children = _ref.children,
    onSubmit = _ref.onSubmit,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
      console.warn('The `<Form>` component has been deprecated. It will be removed in a future breaking change. Please use the HTML `<form>` element instead.');
    }
  }, []);
  function handleSubmit(event) {
    if (_typeof(event) === 'object' && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
    if (typeof onSubmit === 'function') {
      onSubmit(event);
    }
  }
  return /*#__PURE__*/React.createElement("form", _extends({
    id: id,
    className: classNames('lm-Form', className),
    noValidate: novalidate,
    onSubmit: handleSubmit
  }, otherProps), children);
};
Form.propTypes = {
  /** Add an optional ID to this element: `<form class="lm-Form">`. */id: _pt.string,
  /** Add custom classes to this element: `<form class="lm-Form">`. */className: _pt.string,
  /**
     * When present, it specifies that the form-data (input) should not be validated when submitted.
     * @default false
     * */
  novalidate: _pt.bool,
  /** Pass a function to execute when the Form is submitted. */onSubmit: _pt.func,
  /** Pass FieldGroups, Buttons, and form field components as children. Children are passed this element: `<form class="lm-Form">`. */children: _pt.node
};